export class ApiError extends Error {
  status: number
  constructor(status: number, message: string) {
    super(message)
    this.name = 'ApiError'
    this.status = status
  }
}

type Method = 'GET' | 'POST' | 'PUT' | 'DELETE'

async function request<T>(method: Method, path: string, body?: unknown): Promise<T> {
  const res = await fetch(`/api${path}`, {
    method,
    credentials: 'include',
    headers: body !== undefined ? { 'Content-Type': 'application/json' } : undefined,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  })

  const contentType = res.headers.get('content-type') ?? ''
  const data = contentType.includes('application/json') ? await res.json() : null

  if (!res.ok) {
    // Sessão expirada/inválida (401): em vez de deixar a UI "logada mas quebrada"
    // (cada request falhando em silêncio), manda pro login. As rotas /auth/* são
    // tratadas pelo AuthContext, então não redirecionamos nelas.
    if (
      res.status === 401 &&
      !path.startsWith('/auth/') &&
      window.location.pathname !== '/login'
    ) {
      window.location.assign('/login')
    }
    const message = (data && (data.error as string)) || res.statusText || 'Erro na requisição'
    throw new ApiError(res.status, message)
  }

  return data as T
}

export const api = {
  get: <T>(path: string) => request<T>('GET', path),
  post: <T>(path: string, body?: unknown) => request<T>('POST', path, body),
  put: <T>(path: string, body?: unknown) => request<T>('PUT', path, body),
  del: <T>(path: string) => request<T>('DELETE', path),
}
